import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ComingSoon } from '@/app/shell';

/** "Foydalanish qo'llanmasi" — user guide (03-modules §1.4). Placeholder until the feature lands. */
export const Route = createFileRoute('/_authed/_app/guide')({
  component: GuidePage,
});

function GuidePage() {
  const { t } = useTranslation('shell');
  return <ComingSoon title={t('pages.guide')} />;
}
